import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationModule } from 'src/core-lib/navigation/navigation.module';
import { BreadcrumbsComponent, BreadcrumbsGridComponent } from './breadcrumbs.component';



@NgModule({
  declarations: [
      BreadcrumbsComponent,
      BreadcrumbsGridComponent
  ],
  imports: [
    CommonModule,
    NavigationModule,
    TranslateModule
  ],
  exports: [
    BreadcrumbsComponent
  ]
})
export class BreadcrumbsModule {
    static components = { 'breadcrumbsElement': BreadcrumbsGridComponent };
}
